import React, { useEffect, useState } from 'react';
import { Family } from '../../../shared/src/types/Family'; 
import Input from '../components/UI/Input';

interface FamilySearchProps {
  families: Family[];
  onSearchResultsChange: (filtered: Family[]) => void;
}

const FamilySearch: React.FC<FamilySearchProps> = ({ families, onSearchResultsChange }) => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    const q = query.trim().toLowerCase();
    const filtered = families.filter((fam) =>
      fam.family?.toLowerCase().includes(q) ||
      fam.name_a?.toLowerCase().includes(q) ||
      fam.name_b?.toLowerCase().includes(q)
    );
    onSearchResultsChange(filtered);
  }, [query, families, onSearchResultsChange]);

  return (
    <Input
      type="text"
      placeholder="הכנס שם משפחה או שם פרטי"
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      className="w-full md:w-2/3"
    />
  );
};

export default FamilySearch;
